<template>
  <scout-topic-panel
    title="本日のおすすめ"
    name="pickup"
    tooltip="アクティブで応募につながり易い会員を自動抽出します。"
  >
    <router-link
      v-if="!hasEndedContract(contractId)"
      :to="{ name: 'scoutRecommended', params: { contractId: contractId, jobId: jobId } }"
      class="boss-button boss-button-fill boss-button-pickup "
      data-test="recommendation-link"
    >
      <span class="boss-button-before boss-icon-triangle" />
      <span>見る</span>
    </router-link>
  </scout-topic-panel>
</template>

<script>
import ScoutTopicPanel from '@/components/atoms/ScoutTopicPanel'
import { mapGetters } from 'vuex'

export default {
  components: { ScoutTopicPanel },
  props: {
    jobId: {
      type: Number,
      required: true
    },
    contractId: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters('contracts', [
      'hasEndedContract'
    ])
  }
}

</script>
